
class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
			button: this.querySelector('.disclosure__button'),
			panel: this.querySelector('.disclosure__list'),
		};
		this.elements.button.addEventListener('click', this.openSelector.bind(this));
		this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('form');
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute('hidden');
		this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
	}

	closeSelector(event) {
		const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);

const swiper1 = new Swiper(".banner_slider1", {
	// Optional parameters
	slidesPerView: 1,
	grabCursor: true,
	loop: true,
	mousewheel: false,
	keyboard: {
		enabled: true
	},
	autoplay: {
		delay: 4000,
	},
	// If we need navigation
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},

	// Responsive breakpoints
	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 0
		},
		1024: {
			slidesPerView: 1,
			spaceBetween: 0
		}
	}
});


const swiper2 = new Swiper(".banner_slider", {
	// Optional parameters
	slidesPerView: 1,
	grabCursor: true,
	loop: true,
	mousewheel: false,
	autoplay: {
		delay: 4000,
	},

	pagination: {
		el: ".swiper-pagination",
		dynamicBullets: false,
		clickable: true
	},

	// If we need navigation
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},

	// Responsive breakpoints
	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 0
		},
		1024: {
			slidesPerView: 1,
			spaceBetween: 0
		}
	}
});
const swiper3 = new Swiper(".mySwiper", {
	// Optional parameters
	slidesPerView: 1,
	grabCursor: true,
	loop: false,
	mousewheel: false,
	keyboard: {
		enabled: true
	},
	// If we need navigation
	navigation: {
		nextEl: ".swiper-button-next1",
		prevEl: ".swiper-button-prev1"
	},

	// Responsive breakpoints
	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 0
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 20
		}
	}
});


function changemaster() {
	var master = document.querySelectorAll('#masterselect option');
	var selected = document.querySelectorAll('.menu_link1.variant-swatch-option.active');
	var variantname = '';

	for (let i = 0; i < selected.length; i++) {
		const element = selected[i].getAttribute('data-title');
		if (i == selected.length - 1) {
			variantname = variantname + element;
		} else {
			variantname = variantname + element + ' / ';
		}
	}

	var choosen = false;
	var available = false;
	var id = '';
	for (let j = 0; j < master.length; j++) {
		const element = master[j].getAttribute('data-index');
		if (element == variantname) {
			id = master[j].getAttribute('value');
			document.querySelector('#masterselect').value = id;
			price = master[j].getAttribute('data-price');
			var choosen = true;
			available = master[j].getAttribute('data-available');
			document.querySelector('.price-main').textContent = price;
		}
	}

	var availabletext = document.querySelector('#masterselect').getAttribute('data-available-text');
	var soldouttext = document.querySelector('#masterselect').getAttribute('data-solout-text');
	var unavailabletext = document.querySelector('#masterselect').getAttribute('data-unavailable-text');

	if (choosen) {
		if (available == 'true') {
			document.querySelector('.latest-add-to-cart-btn').textContent = availabletext;
			document.querySelector('.latest-add-to-cart-btn').removeAttribute('disabled');
		} else if (available == 'false') {
			document.querySelector('.latest-add-to-cart-btn').textContent = soldouttext;
			document.querySelector('.latest-add-to-cart-btn').setAttribute('disabled', 'disabled');
		}
	} else {
		return;
		document.querySelector('.latest-add-to-cart-btn').textContent = unavailabletext;
		document.querySelector('.latest-add-to-cart-btn').setAttribute('disabled', 'disabled');
	}

	var nextURL = window.location.pathname + '?variant=' + id;
	window.history.replaceState('', '', nextURL);
}

const slideButton = document.getElementById('slideButton');
const parentBox = document.querySelector('.Newsletter_section');
if (slideButton && parentBox) {
	slideButton.addEventListener('click', () => {
		parentBox.classList.toggle('show'); // Toggle 'show' class on button click
	});
}

const slideButton1 = document.getElementById('canclebtn-button');
const parentBox1 = document.querySelector('.Newsletter_section');
if (slideButton1 && parentBox1) {
	slideButton1.addEventListener('click', () => {
		parentBox1.classList.remove('show'); // Remove 'show' class on button click
	});
}

document.addEventListener("DOMContentLoaded", function () {
	var hideButton = document.getElementById("canclebtn1");
	if (hideButton && hideButton.parentElement) {
		var parentBox = hideButton.parentElement;
		if (hideButton && parentBox) {
			hideButton.addEventListener("click", function () {
				parentBox.style.display = "none";
			});
		}
	}
});


// const items = document.querySelectorAll(".button_span_mobile");

// function toggleAccordion() {
//     const itemToggle = this.getAttribute('aria-expanded');

//     // Close only the clicked item if it was open
//     if (itemToggle === 'false') {
//         this.setAttribute('aria-expanded', 'true');
//     }
// }

// // Add event listeners to each item
// items.forEach(item => {
//     item.addEventListener('click', toggleAccordion);
// });






// items.forEach(item => item.addEventListener('click', toggleAccordion));
// const menuItems1 = document.querySelectorAll('.menu_link1');
// menuItems1.forEach(item => {
//     item.addEventListener('click', () => {
//         // Remove 'active' class from all items
//         menuItems1.forEach(menuItem => {
//             menuItem.classList.remove('active');
//         });
//         // Add 'active' class to the clicked item
//         item.classList.add('active');
//         changemaster();
//     });
// });

// items.forEach(item => item.addEventListener('click', toggleAccordion));
// const menuItems2 = document.querySelectorAll('.menu_link2');
// menuItems2.forEach(item => {
//     item.addEventListener('click', () => {
//         // Remove 'active' class from all items
//         menuItems2.forEach(menuItem => {
//             menuItem.classList.remove('active');
//         });
//         // Add 'active' class to the clicked item
//         item.classList.add('active');
//         changemaster();
//     });
// });
// items.forEach(item => item.addEventListener('click', toggleAccordion));
// const menuItems3 = document.querySelectorAll('.menu_link3');
// menuItems3.forEach(item => {
//     item.addEventListener('click', () => {
//         // Remove 'active' class from all items
//         menuItems3.forEach(menuItem => {
//             menuItem.classList.remove('active');
//         });
//         // Add 'active' class to the clicked item
//         item.classList.add('active');
//         changemaster();
//     });
// });

const swiper4 = new Swiper(".you_me_also_like", {
	// Optional parameters
	slidesPerView: 1,
	grabCursor: true,
	loop: false,
	spaceBetween: 20,
	mousewheel: false,
	keyboard: {
		enabled: true
	},
	// If we need navigation
	navigation: {
		nextEl: ".swiper-icon-next",
		prevEl: ".swiper-icon-prev"
	},

	// Responsive breakpoints
	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 20
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 5
		}
	}
});

const menuIcon = document.getElementById('menuIcon');
const mobileMenu = document.getElementById('mobileMenu');
if (menuIcon) {
	menuIcon.addEventListener('click', () => {
		mobileMenu.classList.toggle('show-menu');
		document.body.classList.toggle('showing-menu');
	});
}





